import React, { useContext } from 'react'
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { CreateCartoMapContext } from '../../../../../contexts/carto-maps-context'
import './style.css'

const ConfirmContent = ({ setIsOpen, onClickConfirm }) => {
    const { zonesSelected } = useContext(CreateCartoMapContext)

    return (
        <CardContent>
            <Typography variant="h5" component="h3">
                Check before creating the visualisation  
            </Typography>              
            <p><b>{zonesSelected.zones.length}</b> Zones are going to be included in the visualisation</p>

            <div className="modal-buttons-wrapper" >
                <Button
                    onClick={() => setIsOpen(false)}
                >
                    <b>Cancel</b>
                </Button>
                <Button 
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={onClickConfirm}
                >
                    <b>Confirm</b>
                </Button>
            </div>
        </CardContent>
    )
}

export default ConfirmContent